const ToastNotification = ({ showToast, message, heading, warningActive }) => {
  return (
    <div className="fixed bottom-0 right-0 m-4">
      {showToast && (
        <div
          className={`p-4 rounded-lg shadow-lg border ${
            warningActive
              ? "bg-yellow-200 border-yellow-500"
              : "bg-white border-gray-200"
          } absolute bottom-10 right-10`}
          style={{ width: "350px" }}
        >
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg
                className={`h-6 w-6 ${
                  warningActive ? "text-yellow-500" : "text-red-500"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.363 3.536a2 2 0 010-2.828l6.364-6.364a2 2 0 012.828 0l6.364 6.364a2 2 0 010 2.828l-6.364 6.364a2 2 0 01-2.828 0l-6.364-6.364z"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm leading-5 font-medium text-gray-900">
                {heading}
              </p>
              <p
                className={`mt-1 text-sm leading-5 ${
                  warningActive ? "text-yellow-700" : "text-gray-500"
                }`}
              >
                {message}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ToastNotification;
